import React from 'react';
import styled from 'styled-components';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import withStyles from '@material-ui/core/styles/withStyles';
import AppAvatar from '../../../../core/Avatar/AppAvatar';
import BusinessInfo from './BusinessInfo';
import { V1UsersiteBusinessesGetOneTypePayload } from '~/models/schema';

const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const ItemAvatar = styled(ListItemAvatar)`
  margin-top: 0;
`;

const Avatar = withStyles((theme) => ({
  root: {
    width: 60,
    height: 60,
    [theme.breakpoints.up('md')]: {
      width: 108,
      height: 108,
      fontSize: theme.typography.pxToRem(27),
    },
  },
}))(AppAvatar);

interface Props extends V1UsersiteBusinessesGetOneTypePayload {}

const BusinessItem = (props: Props) => {
  const { logoUrl, name } = props;
  return (
    <Wrapper>
      <ItemAvatar>
        <Avatar src={logoUrl} loaded alt={name}>
          {name[0]}
        </Avatar>
      </ItemAvatar>
      <BusinessInfo {...props} />
    </Wrapper>
  );
};

export default BusinessItem;
